/* VH redesign kit: shared helpers for vh-* sections. PRESENTATION ONLY: no cart, customer or network calls here. */
(function () {
  if (window.VHK) return;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var VHK = window.VHK = {
    RM: RM,
    $: function (s, r) { return (r || document).querySelector(s); },
    $$: function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); },
    gsapReady: function () { return !!(window.gsap && window.ScrollTrigger) && !RM; },
    /* run fn once GSAP (deferred CDN script) is available; fn(false) if it never loads */
    withGsap: function (fn) {
      var tries = 0;
      (function wait() {
        if (window.gsap && window.ScrollTrigger) { try { gsap.registerPlugin(ScrollTrigger); } catch (e) {} fn(!RM); return; }
        /* the theme's foundation.js normally provides GSAP; after ~1.5 s without it, load one copy from cdnjs */
        if (tries === 30) VHK._loadGsap();
        if (++tries > 120) { fn(false); return; }
        setTimeout(wait, 50);
      })();
    },
    _loadGsap: function () {
      if (VHK._gl || window.gsap) return; VHK._gl = 1;
      var add = function (src, cb) { var t = document.createElement('script'); t.src = src; t.onload = cb; document.head.appendChild(t); };
      add('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js', function () { if (!window.ScrollTrigger) add('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js'); });
    },
    toast: function (msg) {
      var t = document.querySelector('.vh-toast');
      if (!t) { t = document.createElement('div'); t.className = 'vh-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
      t.textContent = msg; t.classList.add('on'); clearTimeout(VHK._tt); VHK._tt = setTimeout(function () { t.classList.remove('on'); }, 2800);
    },
    /* containers marked .vh-rv fade up once when they enter the viewport (complete at rest without any script).
       2026-10-02 perf: an IntersectionObserver + CSS transition (vh-kit.css .vh-rvw/.vh-rvi) instead of one GSAP
       ScrollTrigger per element: no trigger to measure on every refresh. Same look: rise 48px + fade, 1.15s, power3.out. */
    reveals: function (root) { VHK.revealIO(VHK.$$('.vh-rv', root), 48); },
    revealIO: function (els, dy) {
      if (!els.length || !('IntersectionObserver' in window)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var io = VHK._rvio || (VHK._rvio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { VHK._rvio.unobserve(e.target); e.target.classList.add('vh-rvi'); } });
      }, { rootMargin: '0px 0px -12% 0px' }));
      var vh = window.innerHeight || 800;
      var tops = els.map(function (el) { return el.getBoundingClientRect().top; }); /* all reads, then all writes */
      els.forEach(function (el, i) {
        if (tops[i] < vh * 0.88 || el.classList.contains('vh-rvw')) return; /* already on screen: stays as it is */
        el.style.setProperty('--vh-rvy', (dy || 48) + 'px'); el.classList.add('vh-rvw'); io.observe(el);
      });
    },
    /* ONE ScrollTrigger refresh for any burst of requests (2026-10-02 perf): every section used to call refresh() as it
       set up, and each refresh re-measures every trigger on the page (a forced layout per trigger). */
    refresh: function () {
      if (!window.ScrollTrigger) return;
      if (!VHK._rtw) { VHK._rtw = 1; ScrollTrigger.addEventListener('refresh', function () { VHK._rtAt = Date.now(); }); }
      var asked = Date.now();
      clearTimeout(VHK._rt); VHK._rt = setTimeout(function () {
        if (VHK._rtAt && VHK._rtAt >= asked) return; /* ScrollTrigger already re-measured on its own since the request (its load/resize refresh) */
        ScrollTrigger.sort(); ScrollTrigger.refresh();
      }, 200);
    },
    /* bottom edge of the store's sticky top stack (reward bar + header group incl. the "You're shopping with" bar).
       Read-only measurement; the largest value seen is kept so pinned sections never slide under the header. */
    top: function () {
      var m = 0;
      document.querySelectorAll('#retail-reward-bar, .shopify-section-group-header-group, #referralBar, #replicatedInfo').forEach(function (el) {
        var s = getComputedStyle(el);
        if (s.position !== 'sticky' && s.position !== 'fixed') return;
        /* the header section can be 0px tall with its <header> overlaid, so measure its visible children too */
        var gt = el.getBoundingClientRect().top, inner = el.offsetHeight < 400 ? el.offsetHeight : 0;
        el.querySelectorAll(':scope > *, header, #referralBar, #replicatedInfo').forEach(function (c) {
          var r = c.getBoundingClientRect(), cs = getComputedStyle(c);
          if (r.height > 0 && r.height < 300 && cs.position !== 'fixed' && cs.visibility !== 'hidden') inner = Math.max(inner, r.bottom - gt);
        });
        m = Math.max(m, (parseFloat(s.top) || 0) + inner);
      });
      VHK._top = Math.max(VHK._top || 0, Math.round(m));
      return VHK._top;
    },
    ready: function (fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  };
  /* publish the measured top stack as --vh-top on every vh root (scoped, never on <html>; only when it changes) */
var pub = function () {
  var v = VHK.top();
  if (v === VHK._pub) return; VHK._pub = v;
  VHK.$$('.vh-page').forEach(function (el) { el.style.setProperty('--vh-top', v + 'px'); });
  VHK.refresh();
};
VHK.ready(function () {
  pub(); setTimeout(pub, 1500); window.addEventListener('load', pub);
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { VHK._top = 0; pub(); }, 200); });
  /* the header changes size once the page scrolls (transparent -> solid); re-measure while scrolling, and only
     re-lay-out pins when none is active so nothing jumps */
  var last = 0;
  window.addEventListener('scroll', function () {
    var now = Date.now(); if (now - last < 250) return; last = now;
    var prev = VHK._top || 0, v = VHK.top();
    if (v === prev) return;
    var active = window.ScrollTrigger && ScrollTrigger.getAll().some(function (t) { return t.pin && t.isActive; });
    if (!active) pub();
  }, {passive: true});
  if ('ResizeObserver' in window) { var ro = new ResizeObserver(pub); document.querySelectorAll('#retail-reward-bar, .shopify-section-group-header-group').forEach(function (el) { ro.observe(el); }); }
});
})();
